import { render, staticRenderFns } from "./lowPriceRealTimeOperateAdmin.vue?vue&type=template&id=17c7fbfa&scoped=true"
import script from "./lowPriceRealTimeOperateAdmin.vue?vue&type=script&lang=js"
export * from "./lowPriceRealTimeOperateAdmin.vue?vue&type=script&lang=js"
import style0 from "./lowPriceRealTimeOperateAdmin.vue?vue&type=style&index=0&id=17c7fbfa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17c7fbfa",
  null
  
)

export default component.exports